import { render, staticRenderFns } from "./EcommerceStatisticsItems.vue?vue&type=template&id=0a8eb0b8&"
import script from "./EcommerceStatisticsItems.vue?vue&type=script&lang=js&"
export * from "./EcommerceStatisticsItems.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceStatisticsItems.vue?vue&type=style&index=0&id=0a8eb0b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports